export default __webpack_public_path__ + "static/media/google_cloud-icon .57e82b3b.svg";